/**
 * The Firebase web config, from the build's env. A leaf on purpose: both the
 * page (`firebase.ts`) and the service workers (`pwa/swPush.ts`,
 * `pwa/swVDrivePush.ts`) read it, and a worker bundle must not reach anything
 * beyond it.
 */
export const firebaseConfig = {
  apiKey: process.env.NX_FIREBASE_API_KEY,
  authDomain: process.env.NX_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NX_FIREBASE_DATABASE_URL,
  projectId: process.env.NX_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NX_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NX_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NX_FIREBASE_APP_ID,
  measurementId: process.env.NX_FIREBASE_MEASUREMENT_ID,
};
